import { Appointment } from "../../../modals/Appointment";

import { useEffect, useState } from "react";
import moment from "moment";
import { Box } from "@chakra-ui/react";
import Datetime from "react-datetime";
import { JobEstimationDetail } from "../../../modals/JobEstimationDetail";

interface PickUpDisplayProps {
  estimateDetails: JobEstimationDetail;
  task: Appointment | undefined;
}

const PickUpDisplay = (props: PickUpDisplayProps) => {
  const [date, setDate] = useState("");
  const [time, setTime] = useState();

  useEffect(() => {
    if (props.task) {
      let arr = props.task?.note.split("\n");

      setDate(moment(arr[0].split(":-")[1]).format("DD-MMM-YYYY"));
      setTime(arr[1].split(":-")[1]);
    }
  }, [props.task]);

  return (
    <div>
      <p className="heading">Pick up saved</p>
      <br></br>
      <p>
        <b>Time:</b> {time}
      </p>
      <br></br>
      <Box>
        <Datetime
          value={new Date(date)}
          open={true}
          input={false}
          renderDay={(cProps, currDate, selectedDate) => {
            if (
              props.estimateDetails &&
              currDate.startOf("day").isSame(date, "day")
            ) {
              cProps.className += " arrivalCompletionDate";
            }

            return <td {...cProps}>{currDate.date()}</td>;
          }}
          isValidDate={(currentDate, selectedDate) => {
            if (currentDate.startOf("day").isSame(date, "day")) {
              return true;
            } else {
              return false;
            }
          }}
        />
      </Box>
    </div>
  );
};

export default PickUpDisplay;
